export default __webpack_public_path__ + "static/jade-logo-green-07364701a4bb38706d55ec1f6464e8a9.svg";